import { render, staticRenderFns } from "./WorksRank.vue?vue&type=template&id=e8a63d58&scoped=true&"
import script from "./WorksRank.vue?vue&type=script&lang=js&"
export * from "./WorksRank.vue?vue&type=script&lang=js&"
import style0 from "./WorksRank.vue?vue&type=style&index=0&id=e8a63d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a63d58",
  null
  
)

export default component.exports